import rawAppLogoUrl from '@app/assets/images/app-logo.svg';

import { IS_LOCALHOST, typedEnv } from '@app/environment/typed-env';

const prefix = IS_LOCALHOST ? '' : typedEnv.REACT_APP_HOST_URL;
export const getRawImageUrl = {
  rawAppLogoUrl: `${prefix}${rawAppLogoUrl}`,
};
